export const USP_HEIGHT_DESKTOP = 72
export const USP_WIDTH_DESKTOP = 430
export const USP_HEIGHT_MOBILE = 96
export const USP_IMAGE_SIZE = 64
